import React, { Component, Fragment, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { Provider } from "react-redux";
import store from "./common/store";
import { logoutUser, setCurrentUser } from "./common/actions/userActions";
import setAuthToken from "./common/cores/setAuthToken";
import { initSocket } from "./common/cores/socket";
import Headbar from "./components/Layout/Headbar";

import routes from "./routes";
import Spinner from "./containers/Spinner";
import Check from "./containers/Check";
import NewMessage from "./containers/NewMessage";
import MyInfo from "./components/Layout/MyInfo";
import Footbar from "./components/Layout/Footbar";
import Popup from "./components/common/Popup";

import PrivateRoute from "./components/common/PrivateRoute";
import { getIpAddr, isEmpty } from "./common/cores";
import language from "./utils/language.json";
import setLanguageToHeader from "./common/cores/setLanguageToHeader";

if (localStorage.jwtToken) {
  setAuthToken(localStorage.jwtToken);
  const currentTime = Date.now() / 1000;
  const decoded = jwt_decode(localStorage.jwtToken);

  store.dispatch(setCurrentUser(decoded));
  localStorage.setItem("exp", decoded.exp);
  localStorage.setItem("time", currentTime);

  if (localStorage.language) {
    store.dispatch({
      type: "change_language",
      payload: localStorage.getItem("language"),
    });
  }
}

setLanguageToHeader(localStorage.getItem("language"));
initSocket(localStorage.getItem("language"));

const App = () => {
  const lang = localStorage.getItem("language");
  if (isEmpty(lang)) {
    window.lang = language["中国语"];
    localStorage.setItem("language", "中国语");
    window.language = "中国语";
  } else {
    window.language = lang;
    window.lang = language[lang];
    if (isEmpty(window.lang)) {
      window.lang = language["中国语"];
    }
  }
  useEffect(() => {
    //getIpAddr();
  }, []);
  return (
    <Provider store={store}>
      <Router>
        <Fragment>
          <Popup />
          {routes.map((route, index) => {
            return (
              <Switch key={index}>
                <PrivateRoute
                  component={route.component}
                  key={index}
                  path={route.pathname}
                  isPublic={route.isPublic}
                  isMessagePage={route.pathname === "/messages"}
                  messageRouter="/messages"
                  value={route.value}
                  exact={route.exact || false}
                />
              </Switch>
            );
          })}
          <Spinner />
          <Check />
          <NewMessage />
        </Fragment>
      </Router>
    </Provider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js